import React from 'react';

import { Grid } from '@grnhse/seedling/lib/birch/layouts/grid_v2';
import { ExternalLink, Body } from '@grnhse/seedling/lib/birch/typography';
import { withLocalePrefix } from '../../shared/utils/translation';

const t = withLocalePrefix('fraud.fraud_report.footer');

const FraudFooter = () => {
  return (
    <Grid
      sx={{
        marginY: 1,
        paddingRight: 3,
      }}
      data-provides="fraud-footer"
    >
      <Body metadata>
        {t('description')}{' '}
        <ExternalLink
          href="https://support.greenhouse.io/hc/en-us/articles/42738009117467"
          data-provides="learn-about-fraud-detection-link"
          aria-label={t('link_text')}
        >
          {t('link_text')}
        </ExternalLink>
      </Body>
    </Grid>
  );
};

export default FraudFooter;
